import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { InstructorConsentStatusResponse } from "../contracts/InstructorConsentStatusResponse";

/** Loads whether the instructor must accept the current Terms / Privacy. */
export const fetchConsentStatus = createAsyncThunk<
  InstructorConsentStatusResponse,
  void,
  { rejectValue: ApiErrorResponse }
>("instructorConsent/fetchStatus", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<InstructorConsentStatusResponse>(
      "/instructor/consent/status"
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to load consent status"));
  }
});

/** Records acceptance of the current Terms / Privacy and returns the new status. */
export const acceptConsent = createAsyncThunk<
  InstructorConsentStatusResponse,
  void,
  { rejectValue: ApiErrorResponse }
>("instructorConsent/accept", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<InstructorConsentStatusResponse>(
      "/instructor/consent/accept"
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to record consent"));
  }
});
